import React from 'react';
import LabResults from '@lifeomic/phc-web-toolkit/src/components/SubjectViewer/Modules/LabResults';
import MemberDetail from './index';

type LabsContentProps = {
  member: fhir.Patient | null;
  fallback: React.ReactNode;
};

export const LabsContent: React.FC<LabsContentProps> = ({
  member,
  fallback,
}) => {
  if (!member) {
    return <>{fallback}</>;
  }

  return <LabResults patient={member} />;
};

const MemberLabs: React.FC = () => {
  return <MemberDetail section="labs" />;
};

MemberLabs.displayName = 'MemberLabs';
export default MemberLabs;
